export const TAG_OPTIONS = [
    {
        id: 'inbox',
        title: 'Inbox',
    },
    {
        id: 'evergreen',
        title: 'Evergreen',
    },
    {
        id: 'fruh',
        title: 'Früh',
    },
    {
        id: 'newsForward',
        title: 'News Forward',
    },
    {
        id: 'video',
        title: 'Video',
    },
    {
        id: 'WESamstag',
        title: 'WE Samstag',
    },
    {
        id: 'WESonntag',
        title: 'WE Sonntag',
    },
    {
        id: 'feiertag',
        title: 'Feiertag',
    },
];
//# sourceMappingURL=tags-options.js.map